import { FC, useCallback, useEffect } from "react";
import { createPortal } from "react-dom";

import { ExitButton } from "../ExitButton/ExitButton";
import { Icon } from "../Icon/Icon";
import "./ResetScannerModal.css";

type Props = {
  open: boolean;
  onClose: () => void;
};

export const ResetScannerModal: FC<Props> = ({ open, onClose }) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        // The scanner sends Enter after scanning the barcode — close the dialog
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    if (open) {
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, handleKeyDown]);

  const modalRoot = document.querySelector("#modal-root");
  if (!modalRoot || !open) {
    return null;
  }

  return createPortal(
    <div className="ResetScannerModal__backdrop" onClick={onClose}>
      <div
        className="ResetScannerModal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ResetScannerModal__close-button">
          <div className="ResetScannerModal__close-text">Luk</div>
          <ExitButton click={onClose} />
        </div>
        <div className="ResetScannerModal__title">
          <div className="ResetScannerModal__title-text">
            Genindstil scanner
          </div>
        </div>
        <div className="ResetScannerModal__description">
          Scan stregkoden herunder for at nulstille scanneren til
          fabriksindstillinger.
        </div>
        <div className="ResetScannerModal__barcode">
          <Icon name="resetScannerBarcode" width={280} height={80} />
        </div>
        <div className="ResetScannerModal__hint">
          Dialogen lukker automatisk når stregkoden er scannet.
        </div>
      </div>
    </div>,
    modalRoot
  );
};
